const NAME = 'customerMonthlyConsumptions';

export default {
  NAME,
};
